import React from "react";
import { FaFacebookF, FaWhatsapp } from "react-icons/fa";
import "./SubFooter.css";

export default function SubFooter() {
  return (
    <footer className="ijacna-subfooter">
      <div className="ijacna-subfooter-links">
        {/* Column 1 */}
        <div className="ijacna-subfooter-column">
          <a href="/#/#ijacna-about-us">About IJACNA</a>
          <a href="/#/Fees">Fees & Payment</a>
          <a href="/#/#call-for-papers">Current Issue</a>
          <a href="/#/#journal-information">Publication Archive</a>
        </div>

        {/* Column 2 */}
        <div className="ijacna-subfooter-column">
          <a href="/#/OnlineSubmission">Submit Research Paper</a>
          <a href="#">Track Submission Status</a>
          <a href="/#/AuthorsGuideline">Publication Guidelines</a>
          <a href="/#/Topics">Publication Topics</a>
        </div>

        {/* Column 3 */}
        <div className="ijacna-subfooter-column">
          <a href="/#/Reviewers">Reviewers</a>
          <a href="/#/JoinAsReviewer">Join as Reviewer</a>
          <a href="/#/Volumes">Historical Repository</a>
          <a href="#">Get Reviewer Membership Certi.</a>
        </div>

        {/* Column 4 */}
        <div className="ijacna-subfooter-column">
          <a href="/#/policies">Journal Policies</a>
          <a href="/#/usage-policy">Usage Policy</a>
          <a href="/#/content-policy">Content Policies</a>
          <a href="/#/privacy-policy">Privacy Policy</a>
        </div>
      </div>

      <hr className="ijacna-subfooter-line" />

      <div className="ijacna-subfooter-contact">
        <a href="tel:+917402616151">+91-7402616151</a>
        <a href="mailto:ijacna@gmail.com">ijacna@gmail.com</a>
        <a href="/#/ContactUs">Contact Us</a>
      </div>

      <div className="subfooter-bottom">
        <p>© {new Date().getFullYear()} IJACNA — All Rights Reserved.</p>
      </div>
    </footer>
  );
}
